export default {
  titles: {
    page: 'Votre dossier est confirmé !',
  },
};
